import { ATTENDANCE_STATES } from '@/modules/RealtimeAttendance/constants'

export const NOT_ALLOWED_STATUS = [
  ATTENDANCE_STATES.CALL_STARTED,
  ATTENDANCE_STATES.CALL_RESTARTED,
]

export const TAG_VARIANT_ACCOUNT_TYPE = {
  TITULAR: 'information',
  DEPENDENTE: 'primary',
}

export const NAME_BUTTON_BY_ACCOUNT_TYPE = {
  TITULAR: 'Ver meus dependentes',
  DEPENDENTE: 'Voltar para conta titular',
}

export const ALLOWED_SOS_BUTTON_ROUTES = ['/', '/conexa-plus']
